import { c as _c } from "react/compiler-runtime";
import { OwnerBalance, OwnerBalanceMemes } from "@/entities/IBalances";
import { MemeSeason } from "@/entities/ISeason";
import { numberWithCommas } from "@/helpers/Helpers";
import { Fragment } from "react";
import { Accordion, Col, Container, Row, Table } from "react-bootstrap";
import styles from "./UserPageStats.module.scss";
import { UserPageStatsTableHead, UserPageStatsTableHr } from "./UserPageStatsTableShared";
function getRankDisplay(balance: number | undefined, rank: number | undefined) {
  if (!balance || !rank) {
    return "-";
  }
  return `#${numberWithCommas(rank)}`;
}
export default function UserPageStatsCollected(t0) {
  const $ = _c(9);
  const {
    ownerBalance,
    balanceMemes,
    seasons
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="tw-flex pt-2 pb-2"><h3 className="tw-mb-0 tw-text-lg tw-font-semibold tw-text-iron-100">Collected</h3></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== ownerBalance) {
    t2 = <div className="pt-2 pb-2"><UserPageStatsCollectedTotals ownerBalance={ownerBalance} /></div>;
    $[1] = ownerBalance;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== balanceMemes || $[4] !== seasons) {
    t3 = <div className="pt-2 pb-2"><UserPageStatsCollectedMemes balanceMemes={balanceMemes} seasons={seasons} /></div>;
    $[3] = balanceMemes;
    $[4] = seasons;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className="pt-2 pb-2">{t1}{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}
function UserPageStatsCollectedTotals(t0) {
  const $ = _c(118);
  const {
    ownerBalance
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Accordion.Button className={styles.collectedAccordionButton}><b>Overview</b></Accordion.Button>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <UserPageStatsTableHead />;
    t3 = <UserPageStatsTableHr span={6} />;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <td className="!tw-text-[#93939f]"><b>Cards</b></td>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = ownerBalance?.total_balance;
  let t6;
  if ($[4] !== t5) {
    t6 = numberWithCommas(t5);
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t6) {
    t7 = <td className="tw-text-right !tw-text-[#fff]">{t6}</td>;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const t8 = ownerBalance?.memes_balance;
  let t9;
  if ($[8] !== t8) {
    t9 = numberWithCommas(t8);
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t9) {
    t10 = <td className="tw-text-right !tw-text-[#fff]">{t9}</td>;
    $[10] = t9;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  const t11 = ownerBalance?.nextgen_balance;
  let t12;
  if ($[12] !== t11) {
    t12 = numberWithCommas(t11);
    $[12] = t11;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== t12) {
    t13 = <td className="tw-text-right !tw-text-[#fff]">{t12}</td>;
    $[14] = t12;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  const t14 = ownerBalance?.gradients_balance;
  let t15;
  if ($[16] !== t14) {
    t15 = numberWithCommas(t14);
    $[16] = t14;
    $[17] = t15;
  } else {
    t15 = $[17];
  }
  let t16;
  if ($[18] !== t15) {
    t16 = <td className="tw-text-right !tw-text-[#fff]">{t15}</td>;
    $[18] = t15;
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  const t17 = ownerBalance?.memelab_balance;
  let t18;
  if ($[20] !== t17) {
    t18 = numberWithCommas(t17);
    $[20] = t17;
    $[21] = t18;
  } else {
    t18 = $[21];
  }
  let t19;
  if ($[22] !== t18) {
    t19 = <td className="tw-text-right !tw-text-[#fff]">{t18}</td>;
    $[22] = t18;
    $[23] = t19;
  } else {
    t19 = $[23];
  }
  let t20;
  if ($[24] !== t10 || $[25] !== t13 || $[26] !== t16 || $[27] !== t19 || $[28] !== t7) {
    t20 = <tr>{t4}{t7}{t10}{t13}{t16}{t19}</tr>;
    $[24] = t10;
    $[25] = t13;
    $[26] = t16;
    $[27] = t19;
    $[28] = t7;
    $[29] = t20;
  } else {
    t20 = $[29];
  }
  let t21;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <td className="!tw-text-[#93939f]"><b>Rank</b></td>;
    $[30] = t21;
  } else {
    t21 = $[30];
  }
  const t22 = ownerBalance?.total_balance;
  const t23 = ownerBalance?.total_balance_rank;
  let t24;
  if ($[31] !== t22 || $[32] !== t23) {
    t24 = getRankDisplay(t22, t23);
    $[31] = t22;
    $[32] = t23;
    $[33] = t24;
  } else {
    t24 = $[33];
  }
  let t25;
  if ($[34] !== t24) {
    t25 = <td className="tw-text-right !tw-text-[#fff]">{t24}</td>;
    $[34] = t24;
    $[35] = t25;
  } else {
    t25 = $[35];
  }
  const t26 = ownerBalance?.memes_balance;
  const t27 = ownerBalance?.memes_balance_rank;
  let t28;
  if ($[36] !== t26 || $[37] !== t27) {
    t28 = getRankDisplay(t26, t27);
    $[36] = t26;
    $[37] = t27;
    $[38] = t28;
  } else {
    t28 = $[38];
  }
  let t29;
  if ($[39] !== t28) {
    t29 = <td className="tw-text-right !tw-text-[#fff]">{t28}</td>;
    $[39] = t28;
    $[40] = t29;
  } else {
    t29 = $[40];
  }
  const t30 = ownerBalance?.nextgen_balance;
  const t31 = ownerBalance?.nextgen_balance_rank;
  let t32;
  if ($[41] !== t30 || $[42] !== t31) {
    t32 = getRankDisplay(t30, t31);
    $[41] = t30;
    $[42] = t31;
    $[43] = t32;
  } else {
    t32 = $[43];
  }
  let t33;
  if ($[44] !== t32) {
    t33 = <td className="tw-text-right !tw-text-[#fff]">{t32}</td>;
    $[44] = t32;
    $[45] = t33;
  } else {
    t33 = $[45];
  }
  const t34 = ownerBalance?.gradients_balance;
  const t35 = ownerBalance?.gradients_balance_rank;
  let t36;
  if ($[46] !== t34 || $[47] !== t35) {
    t36 = getRankDisplay(t34, t35);
    $[46] = t34;
    $[47] = t35;
    $[48] = t36;
  } else {
    t36 = $[48];
  }
  let t37;
  if ($[49] !== t36) {
    t37 = <td className="tw-text-right !tw-text-[#fff]">{t36}</td>;
    $[49] = t36;
    $[50] = t37;
  } else {
    t37 = $[50];
  }
  const t38 = ownerBalance?.memelab_balance;
  const t39 = ownerBalance?.memelab_balance_rank;
  let t40;
  if ($[51] !== t38 || $[52] !== t39) {
    t40 = getRankDisplay(t38, t39);
    $[51] = t38;
    $[52] = t39;
    $[53] = t40;
  } else {
    t40 = $[53];
  }
  let t41;
  if ($[54] !== t40) {
    t41 = <td className="tw-text-right !tw-text-[#fff]">{t40}</td>;
    $[54] = t40;
    $[55] = t41;
  } else {
    t41 = $[55];
  }
  let t42;
  if ($[56] !== t25 || $[57] !== t29 || $[58] !== t33 || $[59] !== t37 || $[60] !== t41) {
    t42 = <tr>{t21}{t25}{t29}{t33}{t37}{t41}</tr>;
    $[56] = t25;
    $[57] = t29;
    $[58] = t33;
    $[59] = t37;
    $[60] = t41;
    $[61] = t42;
  } else {
    t42 = $[61];
  }
  let t43;
  if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = <UserPageStatsTableHr span={6} />;
    $[62] = t43;
  } else {
    t43 = $[62];
  }
  let t44;
  if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
    t44 = <td className="!tw-text-[#93939f]"><b>TDH</b></td>;
    $[63] = t44;
  } else {
    t44 = $[63];
  }
  let t45;
  if ($[64] !== ownerBalance) {
    t45 = ownerBalance ? numberWithCommas(Math.round(ownerBalance.boosted_tdh)) : "-";
    $[64] = ownerBalance;
    $[65] = t45;
  } else {
    t45 = $[65];
  }
  let t46;
  if ($[66] !== t45) {
    t46 = <td className="tw-text-right !tw-text-[#fff]">{t45}</td>;
    $[66] = t45;
    $[67] = t46;
  } else {
    t46 = $[67];
  }
  let t47;
  if ($[68] !== ownerBalance) {
    t47 = ownerBalance ? numberWithCommas(Math.round(ownerBalance?.boosted_memes_tdh)) : "-";
    $[68] = ownerBalance;
    $[69] = t47;
  } else {
    t47 = $[69];
  }
  let t48;
  if ($[70] !== t47) {
    t48 = <td className="tw-text-right !tw-text-[#fff]">{t47}</td>;
    $[70] = t47;
    $[71] = t48;
  } else {
    t48 = $[71];
  }
  let t49;
  if ($[72] !== ownerBalance) {
    t49 = ownerBalance ? numberWithCommas(Math.round(ownerBalance?.boosted_nextgen_tdh)) : "-";
    $[72] = ownerBalance;
    $[73] = t49;
  } else {
    t49 = $[73];
  }
  let t50;
  if ($[74] !== t49) {
    t50 = <td className="tw-text-right !tw-text-[#fff]">{t49}</td>;
    $[74] = t49;
    $[75] = t50;
  } else {
    t50 = $[75];
  }
  let t51;
  if ($[76] !== ownerBalance) {
    t51 = ownerBalance ? numberWithCommas(Math.round(ownerBalance?.boosted_gradients_tdh)) : "-";
    $[76] = ownerBalance;
    $[77] = t51;
  } else {
    t51 = $[77];
  }
  let t52;
  if ($[78] !== t51) {
    t52 = <td className="tw-text-right !tw-text-[#fff]">{t51}</td>;
    $[78] = t51;
    $[79] = t52;
  } else {
    t52 = $[79];
  }
  let t53;
  if ($[80] === Symbol.for("react.memo_cache_sentinel")) {
    t53 = <td className="text-right !tw-text-[#93939f]">*</td>;
    $[80] = t53;
  } else {
    t53 = $[80];
  }
  let t54;
  if ($[81] !== t46 || $[82] !== t48 || $[83] !== t50 || $[84] !== t52) {
    t54 = <tr>{t44}{t46}{t48}{t50}{t52}{t53}</tr>;
    $[81] = t46;
    $[82] = t48;
    $[83] = t50;
    $[84] = t52;
    $[85] = t54;
  } else {
    t54 = $[85];
  }
  let t55;
  if ($[86] === Symbol.for("react.memo_cache_sentinel")) {
    t55 = <td className="!tw-text-[#93939f]"><b>Rank</b></td>;
    $[86] = t55;
  } else {
    t55 = $[86];
  }
  const t56 = ownerBalance?.boosted_tdh;
  const t57 = ownerBalance?.boosted_tdh_rank;
  let t58;
  if ($[87] !== t56 || $[88] !== t57) {
    t58 = getRankDisplay(t56, t57);
    $[87] = t56;
    $[88] = t57;
    $[89] = t58;
  } else {
    t58 = $[89];
  }
  let t59;
  if ($[90] !== t58) {
    t59 = <td className="tw-text-right !tw-text-[#fff]">{t58}</td>;
    $[90] = t58;
    $[91] = t59;
  } else {
    t59 = $[91];
  }
  const t60 = ownerBalance?.boosted_memes_tdh;
  const t61 = ownerBalance?.boosted_memes_tdh_rank;
  let t62;
  if ($[92] !== t60 || $[93] !== t61) {
    t62 = getRankDisplay(t60, t61);
    $[92] = t60;
    $[93] = t61;
    $[94] = t62;
  } else {
    t62 = $[94];
  }
  let t63;
  if ($[95] !== t62) {
    t63 = <td className="tw-text-right !tw-text-[#fff]">{t62}</td>;
    $[95] = t62;
    $[96] = t63;
  } else {
    t63 = $[96];
  }
  const t64 = ownerBalance?.boosted_nextgen_tdh;
  const t65 = ownerBalance?.boosted_nextgen_tdh_rank;
  let t66;
  if ($[97] !== t64 || $[98] !== t65) {
    t66 = getRankDisplay(t64, t65);
    $[97] = t64;
    $[98] = t65;
    $[99] = t66;
  } else {
    t66 = $[99];
  }
  let t67;
  if ($[100] !== t66) {
    t67 = <td className="tw-text-right !tw-text-[#fff]">{t66}</td>;
    $[100] = t66;
    $[101] = t67;
  } else {
    t67 = $[101];
  }
  const t68 = ownerBalance?.boosted_gradients_tdh;
  const t69 = ownerBalance?.boosted_gradients_tdh_rank;
  let t70;
  if ($[102] !== t68 || $[103] !== t69) {
    t70 = getRankDisplay(t68, t69);
    $[102] = t68;
    $[103] = t69;
    $[104] = t70;
  } else {
    t70 = $[104];
  }
  let t71;
  if ($[105] !== t70) {
    t71 = <td className="tw-text-right !tw-text-[#fff]">{t70}</td>;
    $[105] = t70;
    $[106] = t71;
  } else {
    t71 = $[106];
  }
  let t72;
  if ($[107] === Symbol.for("react.memo_cache_sentinel")) {
    t72 = <td className="text-right !tw-text-[#93939f]">* No TDH</td>;
    $[107] = t72;
  } else {
    t72 = $[107];
  }
  let t73;
  if ($[108] !== t59 || $[109] !== t63 || $[110] !== t67 || $[111] !== t71) {
    t73 = <tr>{t55}{t59}{t63}{t67}{t71}{t72}</tr>;
    $[108] = t59;
    $[109] = t63;
    $[110] = t67;
    $[111] = t71;
    $[112] = t73;
  } else {
    t73 = $[112];
  }
  let t74;
  if ($[113] !== t20 || $[114] !== t42 || $[115] !== t54 || $[116] !== t73) {
    t74 = <Accordion><Accordion.Item defaultChecked={true} eventKey="0">{t1}<Accordion.Body className={styles.collectedAccordionBody}><Container><Row className={`pt-2 pb-2 ${styles.scrollContainer}`}><Col><Table className={styles.collectedAccordionTable}>{t2}<tbody>{t3}{t20}{t42}{t43}{t54}{t73}</tbody></Table></Col></Row></Container></Accordion.Body></Accordion.Item></Accordion>;
    $[113] = t20;
    $[114] = t42;
    $[115] = t54;
    $[116] = t73;
    $[117] = t74;
  } else {
    t74 = $[117];
  }
  return t74;
}
function UserPageStatsCollectedMemes(t0) {
  const $ = _c(9);
  const {
    balanceMemes,
    seasons
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function getDisplayWithValueAndRank(value, rank) {
      if (!value) {
        return "-";
      }
      if (!rank) {
        return numberWithCommas(value);
      }
      return <>{numberWithCommas(value)}{" "}<span className="!tw-text-[#93939f]">(#{numberWithCommas(rank)})</span></>;
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const getDisplayWithValueAndRank = t1;
  let t2;
  if ($[1] !== seasons) {
    t2 = function getUniqueDisplay(balanceMemes_0) {
      const seasonBalance = seasons.find(season => season.id === balanceMemes_0.season);
      if (!seasonBalance) {
        return numberWithCommas(balanceMemes_0.unique);
      }
      return <>{balanceMemes_0.unique ? numberWithCommas(balanceMemes_0.unique) : "0"} /{" "}{numberWithCommas(seasonBalance.count)}{" "}<span className="!tw-text-[#93939f]">({(balanceMemes_0.unique / seasonBalance.count * 100).toFixed(0)}%)</span></>;
    };
    $[1] = seasons;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const getUniqueDisplay = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Accordion.Button className={styles.collectedAccordionButton}><b>Memes Breakdown By Season</b></Accordion.Button>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== balanceMemes || $[5] !== getUniqueDisplay) {
    t4 = balanceMemes && <Table className={styles.collectedAccordionTable}><thead><tr><th colSpan={2} /><th className="text-right !tw-text-[#93939f]">Total</th><th className="text-right !tw-text-[#93939f]">Unique</th><th className="text-right !tw-text-[#93939f]">Sets</th><th className="text-right !tw-text-[#93939f]">TDH</th></tr></thead><tbody>{balanceMemes.map(balanceMeme => <Fragment key={`stats-collected-memes-${balanceMeme.season}`}><UserPageStatsTableHr span={6} /><tr><td colSpan={2} className="!tw-text-[#93939f]">Season {balanceMeme.season}</td><td className="tw-text-right !tw-text-[#fff]">{getDisplayWithValueAndRank(balanceMeme.balance, balanceMeme.rank)}</td><td className="tw-text-right !tw-text-[#fff]">{getUniqueDisplay(balanceMeme)}</td><td className="tw-text-right !tw-text-[#fff]">{numberWithCommas(balanceMeme.sets)}</td><td className="tw-text-right !tw-text-[#fff]">{getDisplayWithValueAndRank(balanceMeme.boosted_tdh, balanceMeme.tdh_rank)}</td></tr></Fragment>)}</tbody></Table>;
    $[4] = balanceMemes;
    $[5] = getUniqueDisplay;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <Accordion><Accordion.Item defaultChecked={true} eventKey="0">{t3}<Accordion.Body className={styles.collectedAccordionBody}><Container><Row className={`pt-2 pb-2 ${styles.scrollContainer}`}><Col>{t4}</Col></Row></Container></Accordion.Body></Accordion.Item></Accordion>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}